import * as Yup from 'yup'

export const validationSchema = (t) =>
  Yup.object().shape({
    value: Yup.number().nullable().required(t('form.required')),
  })
